// @ts-nocheck 9e187e5d
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_DatePicker'],
      sections: [addPanel.sections.getSections().developer.datePickerSection],
    };
  },
};
